import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { baseUrl } from "../constants/url";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const Loader = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.div`
  font-size: 1rem;
  color: #333;
`;

const PaymentSuccess = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const sendMessageToReactNative = (status, data) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'PAYMENT_RESULT',
        status,
        data
      }));
    }
  };

  const getPaymentStatusMessage = (status) => {
    if (status === "Success") {
      return "Payment completed successfully";
    } else if ("Aborted") {
      return "Payment cancel";
    } else {
      return "Payment failed";
    }
  }

  useEffect(() => {
    const updatePaymentStatus = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const userToken = params.get("userToken");
        const order_id = params.get("order_id");
        const memberCode = params.get("memberCode");
        const memberId = params.get("memberId");
        const status = params.get("status");
        setStatus(status)
        
        const getPaymentStatus = (status) => {
          if (status === "Success") {
            return "success";
          } else if ("Aborted") {
            return "cancel";
          } else {
            return "failed";
          }
        }

        // if (!userToken || !order_id) {
        //   throw new Error("Missing required parameters");
        // }

        // Send message to React Native and redirect
        sendMessageToReactNative(getPaymentStatus(status), { 
          order_id,
          message: getPaymentStatusMessage(status)
        });

        // Close the WebView after a short delay
        setTimeout(() => {
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
              type: 'CLOSE_WEBVIEW'
            }));
          } else {
            // window.location.assign("http://192.168.1.31:3000")
            window.location.assign("https://app.summairsportsclub.org");
          }
        }, 5000);

        setLoading(false);
      } catch (err) {
        console.error("Payment status update error:", err);
        setError(err.message);
        sendMessageToReactNative('error', { message: err.message });
        setLoading(false);
      }
    };

    updatePaymentStatus();
  }, [location]);

  if (loading) {
    return (
      <Container>
        <Loader />
        <Message>Updating payment status...</Message>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Message style={{ color: "red" }}>Error: {error}</Message>
      </Container>
    );
  }

  return (
    <Container>
      <Loader />
      <Message>{getPaymentStatusMessage(status)}! Redirecting...</Message>
    </Container>
  );
};

export default PaymentSuccess; 